import script from "./FormElementPin.vue?vue&type=script&setup=true&lang=js"
export * from "./FormElementPin.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__